import React from 'react';
import clsx from 'clsx';
import MuiCard from '@material-ui/core/Card';
import { CARD } from 'ctsutheme/core';

const Card = ({
  className, actionable, contained, spaceYellow, ...props
}) => (
  <MuiCard
    className={clsx(
      CARD.root,
      className,
      actionable && CARD.actionable,
      contained && CARD.contained,
      spaceYellow && CARD.spaceYellow
    )}
    {...props}
  />
);
export default Card;
